import { Injectable } from '@angular/core';
import { Observable, Subscriber, Subscription } from 'rxjs';
import { ApiService } from '../base/api.service';
import { ServerResponse } from '../../interfaces/base/server.response';
import { ApiEndpointsService } from '../base/api-endpoints.service';
import { EmailTemplate } from '../../interfaces/configuration/email-template';

@Injectable()

export class EmailTemplateService {

  constructor(private api: ApiService,
              private apiEndpoints: ApiEndpointsService,
  ) {
  }

  all(): Observable<EmailTemplate[] | boolean> {
    return new Observable<EmailTemplate[] | boolean>((o: Subscriber<EmailTemplate[] | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('configuration.email-templates.index'))
        .subscribe((response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<EmailTemplate[]>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  get(id: number): Observable<EmailTemplate | boolean> {
    return new Observable<EmailTemplate | boolean>((o: Subscriber<EmailTemplate | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('configuration.email-templates.read', {':id': id}))
        .subscribe((response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<EmailTemplate>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  create(formData: any): Observable<ServerResponse> {
    return this.api.post(this.apiEndpoints.get('configuration.email-templates.create'), formData);
  }

  update(id: number, formData: any): Observable<ServerResponse> {
    return this.api.put(this.apiEndpoints.get('configuration.email-templates.update', {':id': id}), formData);
  }
}
